import { addLightness, opacify } from '../../../colorMutators/colorMutators/index.js';

const BackgroundsLightInput = '#FCFCFC';
const BackgroundsDarkInput = '#121212';
const backgroundsLightArray = [
    BackgroundsLightInput,
    addLightness(BackgroundsLightInput, -2),
    addLightness(BackgroundsLightInput, -4),
    addLightness(BackgroundsLightInput, -8),
    addLightness(BackgroundsLightInput, -12),
    addLightness(BackgroundsLightInput, -16),
    addLightness(BackgroundsLightInput, -20),
];
const backgroundsDarkArray = [
    BackgroundsDarkInput,
    addLightness(BackgroundsDarkInput, 4),
    addLightness(BackgroundsDarkInput, 8),
    addLightness(BackgroundsDarkInput, 12),
    addLightness(BackgroundsDarkInput, 20),
    addLightness(BackgroundsDarkInput, 28),
    addLightness(BackgroundsDarkInput, 36),
];
const BackgroundsLightValues = Object.freeze({
    base: backgroundsLightArray[0],
    tint1: backgroundsLightArray[1],
    tint2: backgroundsLightArray[2],
    tint3: backgroundsLightArray[3],
    tint4: backgroundsLightArray[4],
    tint5: backgroundsLightArray[5],
    tint6: backgroundsLightArray[6],
    transparent: opacify('#000', 52),
    panel: opacify(backgroundsLightArray[2], 60),
    gradientUp: `linear-gradient(360deg, ${opacify(backgroundsLightArray[0], 80)} 0%, transparent 100%)`,
    gradientDown: `linear-gradient(180deg, ${opacify(backgroundsLightArray[0], 80)} 0%, transparent 100%)`,
    gradientLeft: 'linear-gradient(90deg, #FCFCFC 0%, transparent 100%)',
    gradientRight: 'linear-gradient(270deg, #FCFCFC 0%, transparent 100%)',
    positive: '#ffffff',
    negative: '#000000',
    canvasBackLayer: '#ededed',
});
const BackgroundsDarkValues = Object.freeze({
    base: backgroundsDarkArray[0],
    tint1: backgroundsDarkArray[1],
    tint2: backgroundsDarkArray[2],
    tint3: backgroundsDarkArray[3],
    tint4: backgroundsDarkArray[4],
    tint5: backgroundsDarkArray[5],
    tint6: backgroundsDarkArray[6],
    transparent: opacify('#000', 60),
    panel: opacify(backgroundsDarkArray[2], 60),
    gradientUp: `linear-gradient(360deg, ${opacify(backgroundsDarkArray[0], 80)} 0%, transparent 100%)`,
    gradientDown: `linear-gradient(180deg, ${opacify(backgroundsDarkArray[0], 80)} 0%, transparent 100%)`,
    gradientLeft: 'linear-gradient(90deg, #121212 0%, transparent 100%)',
    gradientRight: 'linear-gradient(270deg, #121212 0%, transparent 100%)',
    positive: '#000000',
    negative: '#ffffff',
    canvasBackLayer: '#262626',
});

export { BackgroundsDarkValues, BackgroundsLightValues };
